export default __webpack_public_path__ + "resources/icons/n231-3260.png";